import { render, staticRenderFns } from "./altriDocumenti.vue?vue&type=template&id=1adfa821"
import script from "./altriDocumenti.vue?vue&type=script&lang=js"
export * from "./altriDocumenti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports